import React from 'react';

const ReportSkeletonLoader: React.FC = () => {
  return (
    <div className="w-full gap-2 bg-offwhite bg-opacity-70 rounded-md p-4 mt-4">
      <h2 className="bg-white p-4 rounded-md shadow-md text-lg mb-4">
        <div className="h-6 w-80 bg-gradient-to-r from-gray to-light-gray rounded-xl opacity-30"></div>
      </h2>
      <div className="w-full bg-offwhite rounded-md shadow-md p-4 my-4 border-t border-gray">
        <h3 className="flex justify-center mb-2 bg-white rounded-md p-2 m-0 text-center">
          <div className="h-5 w-40 bg-gradient-to-r from-gray to-light-gray rounded-xl opacity-30"></div>
        </h3>
        <div className="w-full h-96 bg-white rounded-md shadow-md p-4">
          <div className="h-full w-full bg-gradient-to-r from-gray to-light-gray rounded-md opacity-30"></div>
        </div>
      </div>
      <div className="bg-offwhite p-4 rounded-md shadow-md border-t border-gray">
        <h3 className="flex justify-center mb-2 bg-white rounded-md p-2 m-0 text-center">
          <div className="h-5 w-40 bg-gradient-to-r from-gray to-light-gray rounded-xl opacity-30"></div>
        </h3>
        <div className="flex justify-between items-top gap-4">
          <div className="sm:w-[500px] md:w-[700px] lg:w-[900px] xl:w-[980px] h-96 flex-shrink-0 flex-grow-0 bg-white rounded-md shadow-md p-4">
            <div className="h-full w-full bg-gradient-to-r from-gray to-light-gray rounded-md opacity-30"></div>
          </div>
          <div className="sm:w-48 md:w-56 lg:w-64 h-60 flex-grow-0 bg-white rounded-md shadow-md p-4">
            <div className="h-full w-full bg-gradient-to-r from-gray to-light-gray rounded-full opacity-30"></div>
          </div>
        </div>
      </div>
      <div className="bg-offwhite p-4 rounded-md shadow-md my-4 border-t border-gray">
        <h3 className="flex justify-center mb-2 bg-white rounded-md p-2 m-0 text-center">
          <div className="h-5 w-40 bg-gradient-to-r from-gray to-light-gray rounded-xl opacity-30"></div>
        </h3>
        <div className="flex justify-between items-top gap-4">
          <div className="sm:w-48 md:w-56 lg:w-64 h-60 flex-grow-0 bg-white rounded-md shadow-md p-4">
            <div className="h-full w-full bg-gradient-to-r from-gray to-light-gray rounded-full opacity-30"></div>
          </div>
          <div className="sm:w-[500px] md:w-[700px] lg:w-[900px] xl:w-[980px] h-96 flex-shrink-0 flex-grow-0 bg-white rounded-md shadow-md p-4">
            <div className="h-full w-full bg-gradient-to-r from-gray to-light-gray rounded-md opacity-30"></div>
          </div>
        </div>
      </div>
      <div className="bg-offwhite p-4 rounded-md shadow-md mt-4 border-t border-gray">
        <h3 className="flex justify-center mb-2 bg-white rounded-md p-2 m-0 text-center">
          <div className="h-5 w-40 bg-gradient-to-r from-gray to-light-gray rounded-xl opacity-30"></div>
        </h3>
        <div className="flex justify-between items-top gap-4">
          <div className="sm:w-[500px] md:w-[700px] lg:w-[900px] xl:w-[980px] h-96 flex-shrink-0 flex-grow-0 bg-white rounded-md shadow-md p-4">
            <div className="h-full w-full bg-gradient-to-r from-gray to-light-gray rounded-md opacity-30"></div>
          </div>
          <div className="sm:w-48 md:w-56 lg:w-64 h-60 flex-grow-0 bg-white rounded-md shadow-md p-4">
            <div className="h-full w-full bg-gradient-to-r from-gray to-light-gray rounded-full opacity-30"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportSkeletonLoader;
